import { isOpenNow, statusLabel } from '../../utils/marketStatus';
import { useNow } from '../../hooks/useNow';
import { useTheme } from '../../hooks/useTheme';
import { SunIcon, MoonIcon } from '../primitives/Icon';
import styles from './TopBar.module.css';

/**
 * Live market-status chip — "Open now · until 2 PM" / "Opens Saturday 9 AM".
 * Ticks once a minute so the label flips without a reload.
 */
export function HoursChip() {
  const now = useNow();
  const open = isOpenNow(now);
  return (
    <span className={open ? `${styles.hoursChip} ${styles.hoursChipOpen}` : styles.hoursChip}>
      {statusLabel(now)}
    </span>
  );
}

export function TopBar() {
  const { effectiveTheme, toggle } = useTheme();
  const nextLabel = effectiveTheme === 'dark' ? 'light' : 'dark';
  return (
    <div className={styles.topBar}>
      <div className={styles.brandRow}>
        <img
          src="/assets/images/logo.png"
          alt=""
          width={34}
          height={34}
          className={styles.logoTile}
          aria-hidden="true"
        />
        <div className={styles.wordmark}>
          <span className={styles.display}>Troy Waterfront</span>
          <span className={styles.kicker}>Farmers Market</span>
        </div>
        <button
          type="button"
          className={styles.themeToggle}
          onClick={toggle}
          aria-label={`Switch to ${nextLabel} theme`}
          title={`Switch to ${nextLabel} theme`}
        >
          {effectiveTheme === 'dark' ? <SunIcon size={18} /> : <MoonIcon size={18} />}
        </button>
      </div>
      <HoursChip />
    </div>
  );
}
